import { render, staticRenderFns } from "./FollowPeriodCard.vue?vue&type=template&id=71e705bd&scoped=true"
import script from "./FollowPeriodCard.vue?vue&type=script&lang=js"
export * from "./FollowPeriodCard.vue?vue&type=script&lang=js"
import style0 from "./FollowPeriodCard.vue?vue&type=style&index=0&id=71e705bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e705bd",
  null
  
)

export default component.exports